.profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
}

.lines {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 700;
}

.email {
  overflow: hidden;
  font-size: 14px;
  color: var(--ink-2);
  text-overflow: ellipsis;
}
